module.exports = __webpack_public_path__ + "static/media/Hint3.383ed284.png";